import Vue from 'vue'
// import vuetify from './plugins/vuetify';
import './plugins/vuetify'
import apolloProvider from './plugins/apollo'
import App from './App.vue'
import router from './router'
import store from './store'
import { format, parseISO } from 'date-fns'
import Keycloak from 'keycloak-js'
import VueMeta from 'vue-meta'
import ReadMore from 'vue-read-more';
import VueScrollTo from 'vue-scrollto';
import VueQuillEditor from 'vue-quill-editor';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueLogger from 'vuejs-logger';
import VueClipboard from 'vue-clipboard2'
import VueTheMask from 'vue-the-mask'
import linkify from 'vue-linkify'

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import Block from '@/components/document/generator/block/Block';
import DocumentElement from '@/components/document/generator/element/DocumentElement';
import RootElement from '@/components/document/generator/element/RootElement';
import BlockObjectNavigator from '@/components/document/revision/navigator/BlockObject';
import InlineObjectNavigator from '@/components/document/revision/navigator/InlineObject';
import BlockObjectRender from '@/components/document/revision/render/BlockObject';
import BlockFill from '@/components/document/fill/block/Block';
import DocumentElementFill from '@/components/document/fill/element/DocumentElement';
import RootElementFill from '@/components/document/fill/element/RootElement';

import {
  booleanConverter,
  formatCurrency
} from '@/util/helpers';

Vue.config.productionTip = false

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return format(parseISO(value), 'dd/MM/yyyy HH:mm')
  }
});
Vue.filter('formatDateTimeSeconds', function (value) {
  if (value) {
    return format(parseISO(value), 'dd/MM/yyyy HH:mm:ss')
  }
});
Vue.filter('formatDate', function (value) {
  if (value) {
    return format(parseISO(value), 'dd/MM/yyyy')
  }
});
Vue.filter('formatDay', function (value) {
  if (value) {
    return format(parseISO(value), 'do')
  }
});
Vue.filter('formatMonth', function (value) {
  if (value) {
    return format(parseISO(value), 'MMMM')
  }
});
Vue.filter('formatMonthYear', function (value) {
  if (value) {
    return format(parseISO(value), 'MMMM yyyy')
  }
});
Vue.filter('formatWeekday', function (value) {
  if (value) {
    return format(parseISO(value), 'EEEE')
  }
});
Vue.filter('formatTime', function (value) {
  if (value) {
    return format(parseISO(value), 'HH:mm')
  }
});
Vue.filter('booleanConverter', function (value) {
  if (value) {
    return booleanConverter(value);
  }
});
Vue.filter('toCurrency', function (value) {
  if (typeof value === "number") {
    return formatCurrency(value);
  } else if (typeof value === "string") {
    const valueFloat = parseFloat(value);
    if (!isNaN(valueFloat)) {
      return formatCurrency(valueFloat);
    }
  }
  return value;
});

// these are here to allow recursive
Vue.component("block", Block);
Vue.component("document-element", DocumentElement);
Vue.component("root-element", RootElement);
Vue.component("block-object-navigator", BlockObjectNavigator);
Vue.component("inline-object-navigator", InlineObjectNavigator);
Vue.component("block-object-render", BlockObjectRender);
Vue.component("block-fill", BlockFill);
Vue.component("document-element-fill", DocumentElementFill);
Vue.component("root-element-fill", RootElementFill);

Vue.directive('linkified', linkify)

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});
Vue.use(ReadMore);
Vue.use(VueScrollTo);
// Vue.use(Fragment.Plugin);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDVbj1xcWu-su1OHN32VTIqw0mKWdtb2eg',
    libraries: 'geometry,drawing,places',
    // v: '3.38.2',
  }
});
var quillOptions = {
  debug: 'error',
  modules: {
    toolbar: true
  },
  placeholder: 'Enter text here...',
  readOnly: true,
  theme: 'snow'
};
Vue.use(VueQuillEditor, quillOptions);
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(VueTheMask)

const isProduction = process.env.NODE_ENV === 'production';
const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};
Vue.use(VueLogger, options);
const keycloakPath = `/${process.env.VUE_APP_KC_PATH}`;
var keycloak = new Keycloak(keycloakPath);
Vue.prototype.$keycloak = keycloak

keycloak.init({ onLoad: 'check-sso' }).then(() => {
  setInterval(async () => {
    try {
      const refreshed = await keycloak.updateToken(180)
      if (refreshed) {
        Vue.$log.debug('Token refreshed' + refreshed);
      } else {
        Vue.$log.warn('Token not refreshed, valid for '
          + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
      }
    } catch (err) {
      Vue.$log.error('Failed to refresh token');
      router.go();
    }
  }, 60000)
  new Vue({
    router,
    store,
    apolloProvider,
    render: h => h(App)
  }).$mount('#app')
}).catch(function () {
  Vue.$log.error("Authenticated Failed");
});
// keycloak.onTokenExpired = () => {
//   console.log('token expired', keycloak.token);
//   keycloak.updateToken(30).then((refreshed) => {
//     if (refreshed) {
//       Vue.$log.debug('Token refreshed' + refreshed);
//     } else {
//       Vue.$log.warn('Token not refreshed, valid for '
//         + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
//     }
//   }).catch(() => {
//     Vue.$log.error('Failed to refresh token');
//     router.go();
//   });
// }